import React from 'react';

import { BaseComponent } from '../Component';

import styles from './Flag.module.css';

export interface FlagComponent extends BaseComponent {
  type: 'FlagDisplay';
  props: FlagProps;
}

// Additional flags can be found at https://evoach.atlassian.net/browse/PROD-1162
// You don't need to pass a flag as Enum, you can also use string. That's why
// this component will also work with flags that are not mentioned in the enum
// but exists in the flags folder of this component
export enum FlagEnum {
  BG = 'bg',
  CN = 'cn',
  CZ = 'cz',
  DE = 'de',
  ES = 'es',
  EN = 'en',
  FI = 'fi',
  FR = 'fr',
  GR = 'gr',
  IT = 'it',
  JP = 'jp',
  NL = 'nl',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  SV = 'SV',
  UK = 'uk',
}

// allow both the FlagEnum and a string. We allow string because we would have
// to map strings to enums if we allow enums only. That's what we want to avoid.
export interface FlagProps {
  flag: FlagEnum | string;
  width?: number;
  // we don't need height as flags have a square format
}

export const Flag: React.FC<FlagProps> = ({ width, flag }) => {
  // default width 20 px if width is not provided
  if (!width) {
    width = 20;
  }

  // the style sheet names and the filenames are lower case
  const lflag = (flag as string).toLowerCase();

  // display flag as background image
  // we use this method to display the PNG because this works best when bundling
  // UI-components with webpack and the rollup plugins
  return (
    <span
      className={styles[lflag]}
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: width + 'px ' + width + 'px',
        width: width,
        height: width,
        marginRight: '2px',
      }}
    />
  );
};
